import React, {FC} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Placeholder} from 'semantic-ui-react';

export const UserSettingsPlaceholder: FC = () => {
  return (
    <Placeholder fluid>
      <Placeholder.Header image>
        <Placeholder.Line length={'full'} />
        <Placeholder.Line length={'full'} />
      </Placeholder.Header>
      <Placeholder.Paragraph>
        <Placeholder.Line length="medium" />
        <Placeholder.Line length="short" />
      </Placeholder.Paragraph>
    </Placeholder>
  );
};
